import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import Dialog from '../../dialog/Dialog';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../../../state/hooks';
import strings from '../../../translations';
import WarningDialogContent from '../WarningDialogContent';
import { setWarning } from '../../../state/slices/uiSlice';

const WarningDialog = () => {
  const warning = useAppSelector((state) => state.ui.warning);
  const { store } = useContext(ReactReduxContext);
  
  const handleCloseWarning = () => {
    store.dispatch(setWarning(null));
  };

  return warning !== null ? (
    <Dialog
      drag={false}
      resize={false}
      backdrop
      fullScreenOnMobile={true}
      titleIcon={faExclamationCircle}
      title={strings.general.warning}
      type={'warning'}
      closeAction={handleCloseWarning}
      id={null}
      maxWidth={'45rem'}
      minWidth='30rem'
      minHeight='10rem'
      style={{zIndex: '9999'}}
    >
      <WarningDialogContent warning={warning} />
    </Dialog>
  )
  : null ;
};

export default WarningDialog;
